import { createContext } from "react";

export const HeadContext = createContext(null);
